import { UpsertDeviceDto } from '@diritto/common/account/dtos/device.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class AccountDeviceApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async addDeviceInfo(deviceInfo: UpsertDeviceDto) {
    const res = await this.http.post(`${this.url}/device`, deviceInfo);
    return res.data;
  }
}
